import { render, staticRenderFns } from "./CollectionGridHeader.vue?vue&type=template&id=599c1da9&scoped=true&lang=pug&"
import script from "./CollectionGridHeader.vue?vue&type=script&lang=js&"
export * from "./CollectionGridHeader.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGridHeader.vue?vue&type=style&index=0&id=599c1da9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599c1da9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('599c1da9')) {
      api.createRecord('599c1da9', component.options)
    } else {
      api.reload('599c1da9', component.options)
    }
    module.hot.accept("./CollectionGridHeader.vue?vue&type=template&id=599c1da9&scoped=true&lang=pug&", function () {
      api.rerender('599c1da9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionGridHeader.vue"
export default component.exports